"use client";

import {
  faChevronLeft,
  faChevronRight,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { GalleryBlockDoc as GalleryBlockTypes } from "../../types/blocks";
import { Media } from "../../Media/Media";
import { SectionTitle } from "../../ui/SectionTitle";
import type { MediaDoc as MediaType } from "../../types/payload";
import { cn } from "@onclicks/sharedcomponents/ui";
import React, { useState } from "react";

const GalleryBlock: React.FC<GalleryBlockTypes> = (props) => {
  const { images, title } = props;
  const [zoomedImage, setZoomedImage] = useState<MediaType | null>(null);
  const [currentIndex, setCurrentIndex] = useState<number>(0);

  const openZoomedImage = (media: MediaType) => {
    setZoomedImage(media);
  };

  const closeZoomedImage = () => {
    setZoomedImage(null);
  };

  const prevSlide = () => {
    if (images) {
      const prevImage =
        images[(currentIndex - 1 + images.length) % images.length];
      setCurrentIndex(
        (prevIndex) => (prevIndex - 1 + images.length) % images.length,
      );
      if (prevImage) setZoomedImage(prevImage.image as MediaType);
    }
  };

  const nextSlide = () => {
    if (images) {
      const nextImage = images[(currentIndex + 1) % images.length];
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
      if (nextImage) setZoomedImage(nextImage.image as MediaType);
    }
  };

  return (
    <>
      <div className="px-8 w-full">
        {title && <SectionTitle title={title} />}

        {images && (
          <div
            className={cn(
              "flex flex-wrap items-center gap-y-8",
              images.length == 1
                ? "justify-center"
                : "lg:justify-between sm:justify-center",
            )}
          >
            {images.map(
              (media) =>
                media &&
                typeof media === "object" && (
                  <div
                    key={media.id}
                    onClick={() => openZoomedImage(media.image as MediaType)}
                    className="cursor-pointer"
                  >
                    <Media
                      className=""
                      imgClassName={cn(
                        "rounded-lg w-full",
                        images.length == 1 ? "" : "w-[350px] aspect-square",
                      )}
                      priority
                      resource={media.image}
                    />
                  </div>
                ),
            )}
          </div>
        )}
      </div>
      {zoomedImage && (
        <div className="fixed top-0 left-0 w-full h-full bg-black/85 flex place-content-center place-items-center">
          <FontAwesomeIcon
            icon={faXmark}
            className="absolute top-0 right-0 p-5 cursor-pointer text-white"
            onClick={closeZoomedImage}
            size="2x"
          />
          <FontAwesomeIcon
            icon={faChevronLeft}
            className="absolute top-[90%] md:top-[50%] left-[36%] md:left-0 p-5 cursor-pointer text-white"
            onClick={prevSlide}
            size="2x"
          />
          <FontAwesomeIcon
            icon={faChevronRight}
            className="absolute top-[90%] md:top-[50%] right-[36%] md:right-0 p-5 z-80 cursor-pointer text-white"
            onClick={nextSlide}
            size="2x"
          />
          <div
            className="h-[90vh] w-[100vw] md:h-[90vw] md:w-[90vw] flex place-content-center place-items-center cursor-pointer"
            onClick={closeZoomedImage}
          >
            <Media
              resource={zoomedImage}
              priority
              imgClassName="md:w-[60vw] md:h-[60vw] align-center object-contain"
            />
          </div>
        </div>
      )}
    </>
  );
};

export { GalleryBlock };
